import { Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "../layout/Layout";

// === Core domains (Structured) ===
import { ProjectsListPage } from "../projects-dashboard/ProjectsListPage";
import { ProjectDetailPage } from "../projects-dashboard/ProjectDetailPage";
import { GoalsListPage } from "../goals/GoalsListPage";
import { GoalDetailPage } from "../goals/GoalDetailPage";
import { TicketsKanbanPage } from "../tickets/TicketsKanbanPage";
import { TicketDetailPage } from "../tickets/TicketDetailPage";
import { AgentsPage } from "../agents/AgentsPage";
import { MemoryPage } from "../memory/MemoryPage";
import { SkillsPage } from "../skills/SkillsPage";
import { SkillDetailPage } from "../skills/SkillDetailPage";
import { MeetingsPage } from "../pages/MeetingsPage";
import { MeetingDetailPage } from "../pages/MeetingDetailPage";
import { HomePage } from "../pages/HomePage";
import { SessionsPage } from "../sessions/SessionsPage";

// === Standards + chrome ===
import { DashboardArchitecturePage } from "../blueprint/DashboardArchitecturePage";
import { KbBlueprintPage } from "../blueprint/KbBlueprintPage";
import { PitchDocBlueprintPage } from "../blueprint/PitchDocBlueprintPage";
import { KnowledgeBaseListPage } from "../knowledge-base-list/KnowledgeBaseListPage";
import { SettingsPage } from "../pages/SettingsPage";

export const CRM = () => (
  <Layout>
    <Routes>
      {/* Root → Home. */}
      <Route path="/" element={<Navigate to="/home" replace />} />
      <Route path="/home" element={<HomePage />} />

      {/* Meetings (Structured) — route registered, sidebar entry off by default. */}
      <Route path="/meetings" element={<MeetingsPage />} />
      <Route path="/meetings/:id" element={<MeetingDetailPage />} />

      {/* Goals (Structured list + Knowledge — Classic detail). */}
      <Route path="/goals" element={<Navigate to="/goals-list" replace />} />
      <Route path="/goals-list" element={<GoalsListPage />} />
      <Route path="/goals/:slug" element={<GoalDetailPage />} />

      {/* Projects (Structured list + Knowledge — Classic detail). */}
      <Route path="/projects" element={<Navigate to="/projects-list" replace />} />
      <Route path="/projects-list" element={<ProjectsListPage />} />
      <Route path="/projects/:slug" element={<ProjectDetailPage />} />

      {/* Tickets (Kanban list + Knowledge — Classic detail from ISA-12). */}
      <Route path="/tickets" element={<TicketsKanbanPage />} />
      <Route path="/tickets/:slug" element={<TicketDetailPage />} />

      {/* Agents (Structured). */}
      <Route path="/agents" element={<AgentsPage />} />

      {/* Skills (Structured list + Knowledge — Classic detail). */}
      <Route path="/skills" element={<SkillsPage />} />
      <Route path="/skills/:slug" element={<SkillDetailPage />} />

      {/* Daily Sessions — searchable session log. */}
      <Route path="/sessions" element={<SessionsPage />} />

      {/* Memory (Structured). */}
      <Route path="/memory" element={<MemoryPage />} />

      {/* Generic Knowledge renderers. */}
      <Route path="/kb-doc/*" element={<KbBlueprintPage />} />
      <Route path="/pitch-doc/*" element={<PitchDocBlueprintPage />} />

      {/* Knowledge Base index + named standards page. */}
      <Route path="/knowledge-base" element={<KnowledgeBaseListPage />} />
      <Route path="/dashboard-architecture" element={<DashboardArchitecturePage />} />

      {/* Settings (sidebar account dropdown). */}
      <Route path="/settings" element={<SettingsPage />} />

      {/* Anything else falls through to home. */}
      <Route path="*" element={<Navigate to="/home" replace />} />
    </Routes>
  </Layout>
);
